<style lang="scss" scoped>
.pay_value {
  width: 100%;
  text-align: center;
  font-size: 30px;
  color: #252422;
  .mony {
    font-size: 36px;
    color: #ea5756;
  }
}
.wxcode {
  width: 180px;
  margin: 25px auto 5px;
  border: 1px solid #d0d0d0;
  padding: 10px;
  border-radius: 10px;
}
.pay_text {
  display: flex;
  justify-content: center;
  align-items: center;
  .wxicon {
    width: 36px;
    margin-right: 10px;
  }
}
img {
  display: block;
  width: 100%;
}
.pay_btn {
  width: 195px;
  height: 40px;
  background-color: #f85c5a;
  border-radius: 10px;
  line-height: 40px;
  text-align: center;
  color: #ffffff;
  margin: auto;
  cursor: pointer;
}
</style>
<template>
  <div>
    <el-dialog
      width="500px"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
      append-to-body
      :before-close='closeInnerVisible'
      :close-on-click-modal='false'
    >
      <div class="pay_value">应付金额 <span class="mony">¥299.00</span></div>
      <div class="wxcode">
        <!-- <div id="qrcode"></div> -->
        <img src="../../assets/web/ewm.jpg">
      </div>
      <div class="pay_text">
        <p class="wxicon"><img src="../../assets/web/wxicon.png"></p>
        <p>请打开微信扫码支付</p>
      </div>
      <div
        class="pay_btn"
        @click="paySuccess"
      >
        完成充值
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from 'axios';
import QRCode from 'qrcodejs2'  // 引入qrcode
export default {
  props: {
    dialogVisible: Boolean
  },
  data() {
    return {

    }
  },
  methods: {
    closeInnerVisible() {
      this.$parent.closeDialog()
    },
    paySuccess() {
      // localStorage.setItem('website_isMember', 1)
      this.$parent.closeDialog()
    },
    getqrcode() {
      //获取后台二维码地址
      let vm = this;
      let url = '/vip-webapp/recharge/scanPay'
      axios.post(url).then(res => {
        if (res.status == 200 && res.data.code == 0) {
          let code = res.data.data.codeUrl
          vm.$nextTick(() => {
            this.qrcode(code)
          })
        } else {
          if (res.status == 200) {
            vm.$message.error(res.data.msg);
          } else {
            vm.$message.error("充值付款码获取失败");
          }
        }
      })
    },
    qrcode(code) {
      let qrcode = new QRCode('qrcode', {
        width: 180,
        height: 180,
        text: code, // 二维码地址
        colorDark: "#000",
        colorLight: "#fff",
      })
    },
  }
}
</script>